// extracted by mini-css-extract-plugin
export default {"factors":"hkklwKIh0MLGySuZGrij","positive":"gT4JAYd5SjlKwaHR7z79","negative":"HGbLem9hJsIbFjW_uMrG"};